import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { ScannedBasketProduct, ScantoBasketState } from '../models';

import {
  clearScannedProducts,
  setBasketScannedProductEntry,
  updateScannedProductQuantity,
  updateScannedProductQuantitySuccess,
} from './scan-to-basket.actions';

export const adapter = createEntityAdapter<ScannedBasketProduct>({
  selectId: (product) => product.productId,
  sortComparer: false,
});

const initial: ScantoBasketState = adapter.getInitialState({
  updatingScannedProductIdMap: {},
});

export const scanToBasketReducer = createReducer<ScantoBasketState>(
  initial,
  on(setBasketScannedProductEntry, (state, { scannedBasketProduct }) =>
    adapter.upsertOne(scannedBasketProduct, state),
  ),
  on(updateScannedProductQuantity, (state, { scannedBasketProduct }) => ({
    ...state,
    updatingScannedProductIdMap: {
      ...state.updatingScannedProductIdMap,
      [scannedBasketProduct.productId]: true,
    },
  })),
  on(
    updateScannedProductQuantitySuccess,
    (state, { scannedBasketProduct }) => ({
      ...state,
      updatingScannedProductIdMap: {
        ...state.updatingScannedProductIdMap,
        [scannedBasketProduct.productId]: false,
      },
    }),
  ),
  on(clearScannedProducts, (state) => adapter.removeAll(state)),
);
